@if(templateType === templateMode.DROPDOWN){
<div class="multi-role pointer-events-none" [ngStyle]="contentStyle">
  <form [formGroup]="multiRoleForm">
    <div class="w-100">
      <finxone-select-dropdown
        id="multi-role"
        formControlName="organisation"
        [options]="organisationList"
        [optionLabelKey]="'title'"
        [optionValueKey]="'key'"
        [appendToBody]="true"
        [selectedOption]="selectedOrganisation?.title ?? ''"
        [label]="organisationLabel"
        (selectionChange)="organisationChange()"
      ></finxone-select-dropdown>
    </div>

    @if(showRolePreview){
    <div>
      <div class="label-wrapper">
        <label [innerHTML]="selectedPersonaPreview | safeHtml"></label>
      </div>
      <finxone-select-dropdown
        id="multi-role-persona"
        formControlName="role"
        [options]="availablePersonasForOrg"
        [optionLabelKey]="'title'"
        [optionValueKey]="'key'"
        [appendToBody]="true"
        [class.d-none]="!showPersonaDropdown"
        [selectedOption]="selectedRole"
        [label]="'Persona'"
        (selectionChange)="roleChange($event)"
      ></finxone-select-dropdown>
    </div>
    }
  </form>
</div>
}@else{
<finxone-web-frontend-template-list-view
  [listData]="organizationDetails"
  [idleStateTemplate]="idleStateTemplate"
  [selectedStateTemplate]="selectedStateTemplate"
  [selectedItemId]="activeOrganisationId"
  [noRecordsTemplate]="noRecordsTemplate"
  [baseCssStyle]="baseCssStyle"
  [contentStyle]="contentStyle"
  (selectedListItem)="updateSelectedOrganisation($event)"
  [gridHeight]="gridHeight"
  class="template-list"
></finxone-web-frontend-template-list-view>
}
